import {cn} from '../../lib/utils';
import type {CanvasListBlock} from '../types';
import {BlockLayout} from '../block-layout';
import type {BlockRendererProps} from './types';

export const ListBlock = ({block}: BlockRendererProps<CanvasListBlock>) => {
  return (
    <BlockLayout title={block.title}>
      <div className="rounded-lg border border-border bg-background shadow-xs">
        {block.items.map((item, index) => (
          <div
            key={index}
            className={cn(
              'flex items-center gap-3 px-5 py-3',
              index > 0 && 'border-t border-border',
            )}
          >
            <span
              className="flex size-5 shrink-0 items-center justify-center rounded-full border text-xxs font-semibold"
              style={{
                borderColor: 'var(--canvas-primary)',
                backgroundColor:
                  'color-mix(in srgb, var(--canvas-primary) 15%, transparent)',
                color: 'var(--canvas-primary)',
              }}
            >
              {index + 1}
            </span>
            <span className="text-sm leading-relaxed text-foreground">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </BlockLayout>
  );
};

export const listBlockConfig = {
  component: ListBlock,
  isEmpty: (block: CanvasListBlock) => block.items.length === 0,
};
